var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feed"},[_c('div',{staticClass:"container"},[_c('Navbar'),_c('BuzonUser'),_c('Footer')],1),_c('Notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }